// Service del listado "Justificados" del monitoreo de asistencia.
// GET /attendance/monitoring/justified

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_ListMonitoringJustifiedIn,
  LC_ListMonitoringJustifiedOut,
} from '../types/monitoringJustified.types';


export class MonitoringJustifiedService {
  async get(
    params: LC_ListMonitoringJustifiedIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_ListMonitoringJustifiedOut>> {
    const query = buildQueryString({ ...params });
    const endpoint = `${API_CONFIG.ENDPOINTS.MONITORING_JUSTIFIED}${query}`;

    return apiClient.get<LC_ListMonitoringJustifiedOut>(endpoint, { signal });
  }
}

export const monitoringJustifiedService = new MonitoringJustifiedService();
